import { Link } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

/** 404 for signed-in users: keeps the app shell and points back to the course or dashboard. */
export function AppNotFoundPage() {
  const { user } = useAuth();
  const home = user?.role === 'PARENT' ? '/parent' : '/dashboard';
  const showCourse = user?.role === 'STUDENT' && user?.satEnabled;

  return (
    <>
      <title>Page not found | Mentara</title>
      <meta name="robots" content="noindex" />
      <Layout>
        <div className="mx-auto max-w-md space-y-4 py-16 text-center" data-testid="app-not-found">
          <p className="text-5xl font-bold tracking-tight text-primary">404</p>
          <h1 className="text-2xl font-semibold tracking-tight">We could not find that page</h1>
          <p className="text-muted-foreground">It may have moved, or the link may be wrong.</p>
          <div className="flex flex-col justify-center gap-2 pt-2 sm:flex-row">
            {showCourse && (
              <Button asChild>
                <Link to="/sat">Go to your course</Link>
              </Button>
            )}
            <Button asChild variant={showCourse ? 'outline' : 'default'}>
              <Link to={home}>Go to your dashboard</Link>
            </Button>
          </div>
        </div>
      </Layout>
    </>
  );
}
